import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next-video/dist/components/background-video.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/lib/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fonts/primary/primary-bold.woff2\",\"weight\":\"700\",\"style\":\"normal\"},{\"path\":\"./fonts/primary/primary-boldItalic.woff2\",\"weight\":\"700\",\"style\":\"italic\"},{\"path\":\"./fonts/primary/primary-regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"},{\"path\":\"./fonts/primary/primary-italic.woff2\",\"weight\":\"400\",\"style\":\"italic\"},{\"path\":\"./fonts/primary/primary-semiBold.woff2\",\"weight\":\"600\",\"style\":\"normal\"},{\"path\":\"./fonts/primary/primary-semiBoldItalic.woff2\",\"weight\":\"600\",\"style\":\"Italic\"}],\"variable\":\"--font-primary\"}],\"variableName\":\"fontPrimary\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/lib/fonts/index.ts\",\"import\":\"\",\"arguments\":[{\"src\":[{\"path\":\"./fonts/secondary/secondary-regular.woff2\",\"weight\":\"400\",\"style\":\"normal\"}],\"variable\":\"--font-secondary\"}],\"variableName\":\"fontSecondary\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/Image/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/useQuerySubscription/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/useSiteSearch/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/react-datocms/dist/esm/VideoPlayer/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/logo/logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Blocks/CodeBlock/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/Base/Base.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Core/Base/BaseLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/CodeSnippet/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/Container/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/Div/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/Grid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/MediaQuery/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/Section/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/StoreRoutes/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/Text/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/Title/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Core/UpdateLangSwitch/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Core/VideoPlayerExternal/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Layout/Cursor/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Layout/GradientBg/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Layout/Lenis/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Layout/Modal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Layout/Preload/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Layout/Transition/TransitionIn/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Layout/Transition/TransitionOut/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Project/Cards/CardOffice/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Project/Cards/CardPage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Project/FormBuilder/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Project/Header/components/HeaderTrigger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Project/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Project/Privacy/index.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Sections/SectionOffice/Client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Sections/SectionPrivacy/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Sections/SectionSlider/index.client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Ui/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Ui/DraftModeToggler/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Ui/Iconify/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Ui/LangSwitch/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Ui/NotificationBar/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
